const Sniffer = {
	init: () => {
		{
			let OSName = "unknown"
			if (navigator.userAgent.indexOf("Win") != -1) OSName = "windows"
			else if (navigator.userAgent.indexOf("Mac") != -1) OSName = "macintosh"
			else if (navigator.userAgent.indexOf("Linux") != -1) OSName = "linux"
			else if (navigator.userAgent.indexOf("Android") != -1) OSName = "android"
			else if (navigator.userAgent.indexOf("like Mac") != -1) OSName = "ios"

			document.body.classList.add("is-" + OSName)
		}
	},
}

export default Sniffer
